module.exports = __webpack_public_path__ + "img/hidden.fbbfc072.svg";